import RedFlag from "../../entities/redFlag";

/**
 * RedFlag actions
 *
 * Call order:
 *
 * REDFLAG_SAVE_QUEUE:	adds the item to the save queue
 * --> REDFLAG_SAVE:	modifies the state
 * --> REDFLAG_SAVE_SUCCESS: if all went well
 * --> REDFLAG_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail REDFLAG_SAVE_QUEUE is during the call to REDFLAG_SAVE,
 * as adding an item to the queue should never fail.
 */

export const REDFLAG_FETCH_ONE_QUEUE: any = 'REDFLAG_FETCH_ONE_QUEUE';
export const REDFLAG_FETCH_SUCCESS: any = 'REDFLAG_FETCH_SUCCESS';
export const REDFLAG_FETCH_FAILURE: any = 'REDFLAG_FETCH_FAILURE';
export const REDFLAG_FETCH_ONE_SUCCESS: any = 'REDFLAG_FETCH_ONE_SUCCESS';
export const REDFLAG_FETCH_ONE_FAILURE: any = 'REDFLAG_FETCH_ONE_FAILURE';

export const REDFLAG_SAVE: any = 'REDFLAG_SAVE';
export const REDFLAG_SAVE_QUEUE: any = 'REDFLAG_SAVE_QUEUE';
export const REDFLAG_SAVE_SUCCESS: any = 'REDFLAG_SAVE_SUCCESS';
export const REDFLAG_SAVE_FAILURE: any = 'REDFLAG_SAVE_FAILURE';

export const REDFLAG_SAVE_MANY: any = 'REDFLAG_SAVE_MANY';
export const REDFLAG_SAVE_MANY_QUEUE: any = 'REDFLAG_SAVE_MANY_QUEUE';
export const REDFLAG_SAVE_MANY_SUCCESS: any = 'REDFLAG_SAVE_MANY_SUCCESS';
export const REDFLAG_SAVE_MANY_FAILURE: any = 'REDFLAG_SAVE_MANY_FAILURE';

export const REDFLAG_REMOVE: any = 'REDFLAG_REMOVE';
export const REDFLAG_REMOVE_QUEUE: any = 'REDFLAG_REMOVE_QUEUE';
export const REDFLAG_REMOVE_SUCCESS: any = 'REDFLAG_REMOVE_SUCCESS';
export const REDFLAG_REMOVE_FAILURE: any = 'REDFLAG_REMOVE_FAILURE';

export const REDFLAG_RESTORE: any = 'REDFLAG_RESTORE';
export const REDFLAG_RESTORE_QUEUE: any = 'REDFLAG_RESTORE_QUEUE';
export const REDFLAG_RESTORE_SUCCESS: any = 'REDFLAG_RESTORE_SUCCESS';
export const REDFLAG_RESTORE_FAILURE: any = 'REDFLAG_RESTORE_FAILURE';

export const REDFLAG_RESTORE_MANY: any = 'REDFLAG_RESTORE_MANY';
export const REDFLAG_REMOVE_MANY: any = 'REDFLAG_REMOVE_MANY';

/* Fetch actions */
export const fetchRedFlagSuccess = (redFlags: RedFlag[], partial: boolean, lastFetch: number) => ({type: REDFLAG_FETCH_SUCCESS, redFlags, partial, lastFetch});
export const fetchRedFlagFailure = (err: any) => {
		console.error('RedFlagAction: fetchRedFlagFailure', err);
		return {type: REDFLAG_FETCH_FAILURE, err};
};
export const fetchOneRedFlagQueue = (redFlagId: string) => ({type: REDFLAG_FETCH_ONE_QUEUE, redFlagId});
export const fetchOneRedFlagSuccess = (redFlag: RedFlag) => ({type: REDFLAG_FETCH_ONE_SUCCESS, redFlag});
export const fetchOneRedFlagFailure = (id: string, err: any) => {
		console.error('RedFlagAction: fetchOneRedFlagFailure', err);
		return {type: REDFLAG_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveRedFlag = (redFlag: RedFlag) => {
    // console.debug('⮂ REDFLAG_SAVE action', redFlag?.id);
    return {type: REDFLAG_SAVE, redFlag};
}
export const saveRedFlagQueue = (redFlag: RedFlag) => {
    // console.debug('⮂ REDFLAG_SAVE_QUEUE action', redFlag?.id);
    return {type: REDFLAG_SAVE_QUEUE, redFlag};
}
export const saveRedFlagSuccess = (redFlag: RedFlag) => {
    // console.debug('⮂ REDFLAG_SAVE_SUCCESS action', redFlag?.id);
    return {type: REDFLAG_SAVE_SUCCESS, redFlag};
}
export const saveRedFlagFailure = (redFlag: RedFlag, status: number, message: string) => {
    console.warn(`⮂ REDFLAG_SAVE_FAILURE error saving redFlag: HTTP ${status}: ${message}`, redFlag?.id);
    return {type: REDFLAG_SAVE_FAILURE, redFlag, status, message};
};

/* SaveMany actions */
export const saveManyRedFlags = (redFlags: RedFlag[]) => {
    // console.debug('⮂ REDFLAG_SAVE_MANY action', redFlags?.map(redFlag => redFlag?.id).join(','));
    return {type: REDFLAG_SAVE_MANY, redFlags};
}
export const saveManyRedFlagsQueue = (redFlags: RedFlag[]) => {
    // console.debug('⮂ REDFLAG_SAVE_MANY_QUEUE action', redFlags?.map(redFlag => redFlag.id).join(','));
    return {type: REDFLAG_SAVE_MANY_QUEUE, redFlags};
}

export const saveManyRedFlagsSuccess = (redFlags: RedFlag[]) => {
    // console.debug('⮂ REDFLAG_SAVE_MANY_SUCCESS action', redFlags?.map(redFlag => redFlag.id).join(','));
    return {type: REDFLAG_SAVE_MANY_SUCCESS, redFlags};
}
export const saveManyRedFlagsFailure = (redFlags: RedFlag[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_REDFLAGS_FAILURE Error saving redFlags: HTTP ${status}: ${message}`, redFlags?.map(redFlag => redFlag.id).join(','));
		return {type: REDFLAG_SAVE_MANY_FAILURE, redFlags, status, message};
};

/* Remove actions */
export const removeRedFlag = (redFlag: RedFlag) => ({ type: REDFLAG_REMOVE, redFlag });
export const removeRedFlagQueue = (redFlag: RedFlag) => ({ type: REDFLAG_REMOVE_QUEUE, redFlag });
export const removeRedFlagSuccess = (redFlag: RedFlag) => ({ type: REDFLAG_REMOVE_SUCCESS, redFlag });
export const removeRedFlagFailure = (redFlag: RedFlag, status: number, message: string) => {
	console.error(`Redux: removeRedFlagFailure Error removing redFlag: HTTP ${status}: ${message}`);
	return ({ type: REDFLAG_REMOVE_FAILURE, redFlag, status, message });
};

/* Restore actions */
export const restoreRedFlag = (redFlag: RedFlag) => ({ type: REDFLAG_RESTORE, redFlag });
export const restoreRedFlagQueue = (redFlag: RedFlag) => ({ type: REDFLAG_RESTORE_QUEUE, redFlag });
export const restoreRedFlagSuccess = (redFlag: RedFlag) => ({ type: REDFLAG_RESTORE_SUCCESS, redFlag });
export const restoreRedFlagFailure = (redFlag: RedFlag, status: number, message: string) => {
	console.error(`Redux: restoreRedFlagFailure Error restoring redFlag: HTTP ${status}: ${message}`);
	return ({ type: REDFLAG_RESTORE_FAILURE, redFlag, status, message });
};

/* RestoreMany actions */
export const restoreManyRedFlags = (redFlags: RedFlag[]) => ({ type: REDFLAG_RESTORE_MANY, redFlags });

/* RemoveMany actions */
export const removeManyRedFlags = (redFlags: RedFlag[]) => ({ type: REDFLAG_REMOVE_MANY, redFlags });